<template>
  <div v-if="autoCampaign" class="settings-show">
    <div class="sub-title"><span>settings:</span></div>

    <table class="unstriped settings-show-table">
      <tbody>

        <tr v-if="settings.setBrand" class="brand-detail">
          <td>brand</td>
          <td class="text-right">{{ autoCampaign.advertiser_name || 'incomplete' }}</td>
        </tr>

        <tr v-if="settings.setDateRange" class="start-date-detail">
          <td>start date</td>
          <td class="text-right">{{ acStartDate }}</td>
        </tr>

        <tr v-if="settings.setDateRange" class="end-date-detail">
          <td>end date</td>
          <td class="text-right">{{ acEndDate }}</td>
        </tr>

        <tr v-if="settings.setFrequency" class="frequency-detail">
          <td>frequency</td>
          <td class="text-right">{{ autoCampaign.argument_3 || 'incomplete' }}</td>
        </tr>

        <tr v-if="settings.setSendDay" class="send-day-detail">
          <td>send day of the week</td>
          <td class="text-right">{{ autoCampaign.argument_4 || 'incomplete' }}</td>
        </tr>

        <tr v-if="timeToSend">
          <td>time to send</td>
          <td class="text-right">{{timeToSend}}</td>
        </tr>

        <tr v-if="throttleText">
          <td>{{settings.throttleLabel}}</td>
          <td class="text-right">{{throttleText}}</td>
        </tr>

        <tr v-for="field in argumentFields">
          <td>{{field.label}}</td>
          <td class="text-right">{{field.value}}</td>
        </tr>

        <tr v-if="autoCampaign.type === spendMilestoneType">
          <td>milestone start date</td>
          <!-- argument_4 is the spend milestone date -->
          <td v-if="autoCampaign.argument_4 === null" class="text-right">all time</td>
          <td v-else class="text-right">{{formattedMilestoneDate}}</td>
        </tr>

        <tr>
          <td>created at</td>
          <td class="text-right">{{formattedCreatedAt}}</td>
        </tr>

        <tr>
          <td>updated at</td>
          <td class="text-right">{{formattedUpdatedAt}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
  import ConfigureSettings from '../../mixins/ConfigureSettingsMixin'
  import MerchantTimeZone from '../../mixins/MerchantTimeZoneMixin'
  import { format } from "date-fns"

  export default {
    props: {
      autoCampaign: Object,
      autoCampaignId: String,
    },

    name: 'SettingsShow',

    components: {
    },

    mixins: [ConfigureSettings, MerchantTimeZone],

    data() {
      return {
        argumentFields: null,
        isEnabled: false,
        isShow: true,
        nameValue: null,
        settings: null,
        milestoneStartDate: null,
        spendMilestoneType: 11,
      }
    },

    methods: {
      configureLabels() {
        if (this.settings?.showLabels) {
          const labels = this.settings.showLabels
          let fields = []
          labels.forEach((label, index) => {
            if (label) {
              let arg = `argument_${index + 1}`,
                fieldValue = this.configureFieldValues(arg)
              return fields.push({argType: arg, label: label, value:  fieldValue})
            }
          })
          this.argumentFields = fields
        }
      },

      configureFieldValues(argKey) {
        const acType = this.autoCampaign.type,
          typesThatNeedExtraConfig = [6, 11, 12, 13, 16],
          shouldBeConfigured = typesThatNeedExtraConfig.includes(acType)
        let value = this.autoCampaign[argKey]

        if (shouldBeConfigured) {
          switch (acType) {
            case 6:
              value = this.setDailyDealDay(value)
              break;
            case 11:
              const configuredValue = this.setAddConfigurationValue(value, argKey, 'spend')
              value = argKey === 'argument_1' ? this.setCurrencyValue(value) : configuredValue
              break;
            case 12:
              value = this.setAddConfigurationValue(value, argKey, 'visits')
              break;
            case 13:
              value = argKey === 'argument_1' ? this.setCurrencyValue(value) : value
              break;
            case 16:
              value = this.setBudzValue(value, argKey)
              break;
          }
        }
        return value ? value : 'incomplete'
      },

      initSettings() {
        this.configureSettings()
        this.configureLabels()
      },

      setAddConfigurationValue(value, argKey, arg2word) {
        let configuredValue = value
        if (argKey === 'argument_2') {
          configuredValue = `${arg2word} reached within ${value} day`
          if (value > 1) { configuredValue = `${configuredValue}s` }
        }
        if (argKey === 'argument_3') { configuredValue = value ? 'no' : 'yes' }
        return configuredValue
      },

      setBudzValue(value, argKey) {
        let configuredValue = value
        switch (argKey) {
          case 'argument_1':
            configuredValue =  this.setReferralText(value)
            break;
          case 'argument_2':
            configuredValue =  parseInt(value) > 0 ? this.setCurrencyValue(value) : 'none'
            break;
          case 'argument_3':
            if (value === '-1') { configuredValue = 'unlimited' }
            break;
        }
        return configuredValue
      },

      setCurrencyValue(value) {
        return value ? (parseInt(value)).toLocaleString('en-US', {style: 'currency', currency: 'USD'}) : value
      },

      setDailyDealDay(dayValue) {
        const dayNumber = parseInt(dayValue)
        switch (dayNumber) {
          case 0:
            return 'sunday'
          case 1:
            return 'monday'
          case 2:
            return 'tuesday'
          case 3:
            return 'wednesday'
          case 4:
            return 'thursday'
          case 5:
            return 'friday'
          case 6:
            return 'saturday'
          default:
            return dayValue
        }
      },

      setReferralText(referralValue) {
        const referral = parseInt(referralValue)
        switch (referral) {
          case 1:
            return 'referred click'
          case 2:
            return 'referred join'
          case 3:
            return 'referred purchase'
          default:
            return referralValue
        }
      }
    },

    created() {
      !!this.autoCampaign && this.initSettings()
    },

    computed: {
      formattedCreatedAt: function() {
        return this.autoCampaign && this.formatToMerchantTimeZone(this.autoCampaign.created_at)
      },

      formattedUpdatedAt: function() {
        return this.autoCampaign && this.formatToMerchantTimeZone(this.autoCampaign.updated_at)
      },

      formattedMilestoneDate: function() {
        return this.autoCampaign && this.formatDateOnly(this.autoCampaign.argument_4)
      },

      throttleText: function() {
        const hasThrottle = this.settings?.throttleLabel,
          throttle = this.autoCampaign?.throttle || null,
          onceThrottle = this.autoCampaign?.type === 4 && throttle === -1,
          text = onceThrottle ? 'send once' : throttle
        return hasThrottle ? text : null
      },

      timeToSend: function() {
        if (this.settings?.setTime) {
          const sendAt = this.autoCampaign?.send_at_local
          return sendAt ? this.formatTime(sendAt) : 'incomplete'
        }
      },

      acStartDate() {
        if (this.autoCampaign?.type === 20) {
          const startDate = this.autoCampaign?.argument_1
          return startDate ? format(new Date(startDate), 'MM/dd/yy') : 'incomplete'
        }
      },

      acEndDate() {
        if (this.autoCampaign?.type === 20) {
          const endDate = this.autoCampaign?.argument_2
          return endDate ? format(new Date(endDate), 'MM/dd/yy') : 'incomplete'
        }
      },
    }
  }
</script>
